class BESSAppProjectDaylightEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.#updateTotals();
    }


    updateState() {
        super.updateState();
        this.#updateTotals();
    }

    #updateTotals() {
        this.totalRooms = 0;
        this.totalBedRooms = 0;
        this.totalLivingRooms = 0;
        this.totalArea = 0;
        this._forEachItem(this.#updateTotalsForItem);

        let totalsContent =
            this._createTotalItemContent(this.totalRooms, 'Total ' + pluralise('room', 'rooms', this.totalRooms)) +
            this._createTotalItemContent(this.totalBedRooms, pluralise('Bedroom', 'Bedrooms', this.totalBedRooms)) +
            this._createTotalItemContent(this.totalLivingRooms, pluralise('Living Room', 'Living Rooms', this.totalLivingRooms)) +
            this._createTotalItemContent(Math.floor(this.totalArea), 'Total floor area (Square Metres)');

        this.editor.showTotals(totalsContent);
    }

    #updateTotalsForItem(item) {
        let quantity = item.inputs.quantity.getIntValue(0);
        let area = item.inputs.roomFloorArea.getIntValue(0);
        let type = item.inputs.roomDesignation.getValue();

        this.totalRooms += quantity;
        this.totalArea += (area * quantity);
        if (type !== null) {
            if (type === "1") {
                this.totalBedRooms += quantity;
            } else if (type === "0") {
                this.totalLivingRooms += quantity;
            }
        }
    }
}